const comments = [
  {
    name: '墨染流年',
    text: '超爱耽美漫画网！不用注册就能看全部漫画，画质也特别清晰。每天上班路上必刷几话，已经追了好几个月的《暗香》了，强烈推荐给同好！',
    work: '在读《暗香》',
    time: '2小时前',
  },
  {
    name: '风信子',
    text: '作为资深腐女真心觉得这个网站太良心了，全免费还能看这么多高质量 BL 漫画。古风分类里的作品质量特别高，画风绝美，剧情在线！',
    work: '在读《浮生》',
    time: '5小时前',
  },
  {
    name: '桃之夭夭',
    text: '从朋友推荐过来的，一开始还不太信全免费，用了快一个月发现真的一分钱没收过。更新速度也快，热门作品基本同步更新，爱了爱了！',
    work: '在读《夜行》',
    time: '8小时前',
  },
  {
    name: '半盏清茶',
    text: '校园耽美分类是我的最爱！《青涩》太好看了，画风清新细腻，剧情甜到齁。感谢耽美漫画网让我免费看到这么好的作品，每天刷新等更新～',
    work: '在读《青涩》',
    time: '12小时前',
  },
  {
    name: '夜雨声烦',
    text: '找了好久免费的耽美资源，终于遇到这么靠谱的平台了。分类全、更新快、画质高清，手机看体验也超棒。ABO 和科幻分类里的冷门好作品也不少！',
    work: '在读《星河》',
    time: '1天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            读者心声
          </h2>
          <p className="text-sm text-foreground-500">来自耽美漫画网读者的真实反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((c, idx) => (
            <article key={idx} className="bg-background-50 rounded-lg p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-heading text-sm font-bold">
                    {c.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-heading text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
                <span className="text-[11px] px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap flex-shrink-0">
                  {c.work}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{c.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}